import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import { type NavigateOptions } from 'react-router-dom';
import { useLargeCardNavigate } from '@shared/hooks/use-large-card-navigate.ts';

const windowLocation = window.location;

export const usePagesRedirect = (hash?: string) => {
  const { doRedirectBack, navigate } = useLargeCardNavigate();

  const {
    data: prevPageUrl,
    doSetStorageData: doSetPrevPageUrl,
    doRemoveStorageData: doRemovePrevPageUrl,
  } = useSaveData<string>(hash || 'prevPageUrl');

  const doRedirectWithSavePageUrl = useCallback(
    (navUrl: string, navState?: NavigateOptions) => {
      doSetPrevPageUrl(windowLocation.pathname + windowLocation.search);
      setTimeout(() => navigate(navUrl, navState), 5);
    },
    [navigate, doSetPrevPageUrl]
  );

  const doSavePageUrl = useCallback(
    () => doSetPrevPageUrl(windowLocation.pathname + windowLocation.search),
    [doSetPrevPageUrl]
  );

  const doRedirectOnPrevPage = useCallback(
    (pathName?: string, navState?: NavigateOptions) => {
      if (prevPageUrl) {
        navigate(prevPageUrl, navState);
        doRemovePrevPageUrl();
      } else if (pathName) {
        // console.log('kek');
        navigate(pathName, navState);
      } else {
        doRedirectBack();
      }
    },
    [navigate, prevPageUrl, doRedirectBack, doRemovePrevPageUrl]
  );

  return { prevPageUrl, doRedirectWithSavePageUrl, doRedirectOnPrevPage, doSavePageUrl };
};
